function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 1C0 0.44772 0.44772 0 1 0C1.55228 0 2 0.44772 2 1V2.70836C3.46588 1.0475 5.61062 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.9508 16 0.60422 12.9917 0.07338 9.08812C-0.00780001 8.49112 0.48842 8 1.0909 8C1.59298 8 1.99276 8.4094 2.06792 8.90582C2.50464 11.7897 4.9942 14 8 14C11.3137 14 14 11.3137 14 8C14 4.6863 11.3137 2 8 2C6.223 2 4.62642 2.7725 3.52778 4H5C5.55228 4 6 4.44772 6 5C6 5.55228 5.55228 6 5 6H1C0.44772 6 0 5.55228 0 5V1Z",
  fill: "#717171"
});

var SvgRotationSettings = function SvgRotationSettings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRotationSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rotation_settings.9e3f5aa1.svg";
export { ForwardRef as ReactComponent };